import { createFileRoute } from "@tanstack/react-router";
import type { CustomFieldValues } from "@/convex/companies/custom_fields";
import { CollectionRecordPage } from "@/components/collections/record-form/collection-record-page";

export const Route = createFileRoute("/_authenticated/collections/$collectionId/records/new")({
  validateSearch: (search: Record<string, unknown>) => ({
    /** Valores iniciales en JSON (p. ej. la columna del kanban o el día del calendario). */
    init: typeof search.init === "string" ? search.init : undefined,
  }),
  component: NewRecordPage,
});

function parseInit(raw: string | undefined): CustomFieldValues | undefined {
  if (!raw) return undefined;
  try {
    const value: unknown = JSON.parse(raw);
    return value && typeof value === "object" && !Array.isArray(value) ? (value as CustomFieldValues) : undefined;
  } catch {
    return undefined;
  }
}

/** Registro nuevo en página (la colección eligió «Página» en su formulario). */
function NewRecordPage() {
  const { collectionId } = Route.useParams();
  const { init } = Route.useSearch();
  return <CollectionRecordPage collectionId={collectionId} initialValues={parseInit(init)} />;
}
